import { injectable } from 'inversify';
import { ModelRuleLimit, UnitOptionLimitLimiter } from '@Models';
import { model_rule_limit_full } from '@Api';

@injectable()
export class ModelRuleLimitMapper {
  public map(item: model_rule_limit_full): ModelRuleLimit {
    const limit = this.mapLimiter(item.limit);
    return {
      modelRuleId: item.model_rule_id,
      limit: limit,
      min: item.min,
      max: item.max,
      key: item.key,
      armyOrganisationId: item.army_organisation_id,
      isModel: limit === UnitOptionLimitLimiter.MODEL,
      isModelByUnit: limit === UnitOptionLimitLimiter.MODEL_BY_UNIT,
      isItemByArmy: limit === UnitOptionLimitLimiter.ITEM_BY_ARMY,
      isMaxRatioByArmy: limit === UnitOptionLimitLimiter.MAX_RATIO_BY_ARMY,
    } satisfies ModelRuleLimit as ModelRuleLimit;
  }

  public mapLimiter(
    limit: model_rule_limit_full.limit,
  ): UnitOptionLimitLimiter {
    switch (limit) {
      case model_rule_limit_full.limit.UNITS:
        return UnitOptionLimitLimiter.UNITS;
      case model_rule_limit_full.limit.MODEL_BY_UNIT:
        return UnitOptionLimitLimiter.MODEL_BY_UNIT;
      case model_rule_limit_full.limit.ITEM_BY_ARMY:
        return UnitOptionLimitLimiter.ITEM_BY_ARMY;
      case model_rule_limit_full.limit.MAX_RATIO_BY_ARMY:
        return UnitOptionLimitLimiter.MAX_RATIO_BY_ARMY;
    }

    return UnitOptionLimitLimiter.MODEL;
  }
}
